import React, { PropTypes } from 'react';

const TagItem = ({
  label,
  value,
  onRemoveTagClick
}) => (
    <div className="list-group-item-labeled">
      <div className="list-group-item-labeled-child">
        <b>{`${label}`}</b>
      </div>
      <div className="list-group-item-labeled-child"
        style={{ flexDirection: 'row' }}>
        <button className="btn btn-link"
          type="button"
          onClick={() => onRemoveTagClick(value)}>
          <i className="fa fa-times" /> {'Remove'}
        </button>
      </div>
    </div>
  );

TagItem.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  onRemoveTagClick: PropTypes.func
};

TagItem.defaultProps = {
};

export default TagItem;


// WEBPACK FOOTER //
// ./src/features/tournament/general/TagItem.jsx